export const QUICK_REPLY_FIELDS = {
  name: 'name',
  message: 'message',
  files: 'files',
  fileId: 'fileId',
  fileName: 'filename',
};

export type QuickReplyField = {
  name: string,
  message: string,
  files?: File,
  fileId?: string,
  filename?: string,
};

export const QUICK_REPLY_MESSAGE_INTERPOLATION = {
  clientName: {
    key: 'nombre_cliente',
    value: '{{nombre_cliente}}',
  },
};
